import { useTranslations } from '@vocab/react';

import { getOptionText } from 'src/app/utils/getOptionText';
import type { LanguageAI } from 'src/types/languageAI';

import translations from './.vocab';

export const useLanguageAITaxonomy = () => {
  const { t } = useTranslations(translations);

  const languageAIs = [
    {
      text: t('language-ai-taxonomy-english'),
      value: 'en-AU',
    },
    {
      text: t('language-ai-taxonomy-thailand'),
      value: 'th-TH',
    },
    {
      text: t('language-ai-taxonomy-indonesia'),
      value: 'id-ID',
    },
    {
      text: t('language-ai-taxonomy-traditional-chinese'),
      value: 'zh-HK',
    },
  ];

  const getLanguageAIText = (value: LanguageAI) =>
    getOptionText(languageAIs, value);

  return { languageAIs, getLanguageAIText };
};
